import * as types from 'store/mutation-types'
import dayjs from 'dayjs'
var utc = require('dayjs/plugin/utc')
dayjs.extend(utc)

const state = {}

const getters = {}

const actions = {
  [types.SEND_PAGE_VIEW_EVENT] ({
    dispatch,
    rootState: { auth }
  }, { subsection, subsection2 }) {
    const { user } = auth

    const payload = {
      user_id: user.id,
      event: 'pageview',
      language: user.locale,
      section: 'Checkout Builder',
      subsection,
      subsection2
    }

    window.dataLayer.push(payload)
  },
  [types.SEND_NAVBAR_EVENT] ({
    dispatch
  }, { item }) {
    const payload = {
      event: 'custom_event',
      'custom_event_name': 'click_navbar',
      event_details: item
    }

    window.dataLayer.push(payload)
  },
  [types.SEND_PRODUCT_SEARCH_RESULT_EVENT] ({
    dispatch
  }, { searchTerm }) {
    const payload = {
      event: 'custom_event',
      'custom_event_name': 'view_search_results',
      event_details: searchTerm
    }

    window.dataLayer.push(payload)
  },
  [types.SEND_PRODUCT_LIST_SELECT_EVENT] ({
    dispatch
  }, { productId }) {
    const payload = {
      event: 'custom_event',
      'custom_event_name': 'click_product_list',
      event_details: productId
    }

    window.dataLayer.push(payload)
  },
  [types.SEND_PRODUCT_SELECT_EVENT] ({
    dispatch
  }, { productId }) {
    const payload = {
      event: 'custom_event',
      'custom_event_name': 'click_checkout_builder_product',
      event_details: productId
    }

    window.dataLayer.push(payload)
  },
  [types.SEND_PAGE_SETTINGS_EVENT] ({
    dispatch
  }, { productId }) {
    const payload = {
      event: 'custom_event',
      'custom_event_name': 'click_checkout_builder_page_settings',
      event_details: productId
    }

    window.dataLayer.push(payload)
  },
  [types.SEND_BUILDER_NEW_PAGE_EVENT] ({
    dispatch
  }, { productId }) {
    const payload = {
      event: 'custom_event',
      'custom_event_name': 'click_checkout_builder_new_page',
      event_details: productId
    }

    window.dataLayer.push(payload)
  },
  [types.SEND_CLICK_TEMPLATE_EVENT] ({
    dispatch
  }, { productId, templateType }) {
    const payload = {
      event: 'custom_event',
      'custom_event_name': 'click_template',
      event_details: productId,
      template_type: templateType
    }

    window.dataLayer.push(payload)
  },
  [types.SEND_USE_TEMPLATE_EVENT] ({
    dispatch
  }, { productId, templateType }) {
    const payload = {
      event: 'custom_event',
      'custom_event_name': 'use_template',
      event_details: productId,
      template_type: templateType
    }

    window.dataLayer.push(payload)
  },
  [types.SEND_EDIT_COMPONENT_EVENT] ({
    dispatch,
    rootState: { auth }
  }, { productId, templateType, itemName }) {
    const payload = {
      event: 'custom_event',
      'custom_event_name': 'click_page_edit',
      event_details: productId,
      template_type: templateType,
      item_name: itemName
    }

    window.dataLayer.push(payload)
  },
  [types.SEND_PAGE_SAVE_EVENT] ({
    dispatch
  }, { productId, templateType }) {
    const payload = {
      event: 'custom_event',
      'custom_event_name': 'click_page_save',
      event_details: productId,
      template_type: templateType
    }

    window.dataLayer.push(payload)
  },
  [types.SEND_CHOOSE_ORDER_BUMP_EVENT] ({
    dispatch,
    rootState: { auth }
  }, { productId, templateType }) {
    const payload = {
      event: 'custom_event',
      'custom_event_name': 'click_page_order_bump_choose_product',
      event_details: productId,
      template_type: templateType
    }

    window.dataLayer.push(payload)
  },
  [types.SEND_PAGE_VIEW_EVENT__PRODUCT_SELECT] ({
    dispatch
  }) {
    dispatch(types.SEND_PAGE_VIEW_EVENT, {
      subsection: 'Product Selection'
    })
  },
  [types.SEND_PAGE_VIEW_EVENT__CREATE_NEW_CHECKOUT] ({
    dispatch
  }) {
    dispatch(types.SEND_PAGE_VIEW_EVENT, {
      subsection: 'Create New Checkout'
    })
  },
  [types.SEND_PAGE_VIEW_EVENT__CREATE_NEW_CHECKOUT_FROM_TEMPLATE] ({
    dispatch
  }) {
    dispatch(types.SEND_PAGE_VIEW_EVENT, {
      subsection: 'Create New Checkout From Template'
    })
  },
  [types.SEND_PAGE_VIEW_EVENT__BUILDER] ({
    dispatch
  }) {
    dispatch(types.SEND_PAGE_VIEW_EVENT, {
      subsection: 'Builder'
    })
  },
  [types.SEND_PAGE_VIEW_EVENT__DASHBOARD] ({
    dispatch
  }) {
    dispatch(types.SEND_PAGE_VIEW_EVENT, {
      subsection: 'Dashboard'
    })
  }
}

const mutations = {
}

export default {
  state,
  getters,
  actions,
  mutations,
  namespaced: true
}
